module.exports = __webpack_public_path__ + "static/media/Poppins-Regular.093ee89b.ttf";